import axios from '../../customAxios';
import {
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_FAIL,
} from '../constants/orderConstants';

export const listOrders = (page = 1, limit = 10,search) => async (dispatch) => {  
  try {
    dispatch({ type: ORDER_LIST_REQUEST });

    const { data } = await axios.get(`/api/v1/admin/getOrdersByAdmin?page=${page}&limit=${limit}&search=${search}`); // Replace with the correct API endpoint

    dispatch({
      type: ORDER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ORDER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};